import { updateLinksAttributes } from '../utils/handleAttributes';
import { getWindowSize } from '../utils/helpers';

function mozaicCards(widgetNameVariable, widgetOptsVariable, maxItems) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: getWindowSize(800) ? [''] : ['all'],
    maxItemsVisible: maxItems,
    itemsPerPanel: 6,
    showDescription: false,
    moreButton: false,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createMozaicCards(data.items, $widget);
      } else {
        $widget.remove();
      }
    },
  });
}

function createMozaicCards(widgetData, $widget) {
  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $card = $(this);

    $card.find('.image-container').append('<div class="overlay"></div>');

    if (URL == null || URL == '') {
      $card.find('.buttonwrap').remove();
      $card.addClass('void-link');
    } else {
      $card.find('.buttonwrap').replaceWith(`
        <a ${URL == null || URL === '' ? '' : 'href="' + URL + '"'} class="button" ${updateLinksAttributes(URL, Title)}>
          More
        </a>
        `);
    }
    $card.find('.card-widget-title').wrap('<div class="card-widget-title-wrap"></div>');

    if (!getWindowSize(800)) {
      updateLinksAttributes(URL, Title, $card);
    }
  });
}

export default function updateMozaicCards($widgetItem, $widgetOpts, maxItems) {
  let isMobile;

  function triggerFeature() {
    const matches = globalThis.matchMedia('(max-width: 800px)').matches;
    if (matches === isMobile) return;
    isMobile = matches;

    $(`.mozaicCards-wrapp #${$widgetItem}`).remove();
    $(`.mozaicCards-wrapp .inner-container`).append(
      '<div id="' + $widgetItem + '" class="mozaic-double"></div>',
    );
    mozaicCards($widgetItem, $widgetOpts, maxItems);
  }
  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}
